
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Toast from 'vux/src/components/toast/index.vue'

import mapUtil from "@/javascript/mapUtil";
import EsQuery from "@/javascript/esQuery";
import util from "@/javascript/util";
import loading from "@/components/public-components/loading/index.vue";

import mapList from '@/components/public-components/mapList/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'


export default {
components: {
Tab,
TabItem,
Toast,
loading,
mapList,
goBack
},
data () {
return {
toastText: "您当前位置不在海晏,将为您切换至海晏",
toastShow: false,
value: "",
placeholder: "搜索景区\\攻略\\游记\\住宿\\美食",
weight: true,
curType: "",
typeList: [
"温泉酒店",
"管家服务",
"浪漫情侣",
"休闲度假",
"亲子酒店",
"商务出行",
"快捷连锁",
"中端连锁",
"高端连锁",
"酒店",
"民宿",
"酒店公寓",
"客栈",
"特色住宿",
"农家乐",
],
tabIndex: 0,
showFitlerList: false,
animation: false,
typecar: -1,
selectone: -1,
selecttwo: -1,
dialogShow: false,
dialog2Show: false,
category: "",
sortcont: "",
scenicsListFrom: {
pageNo: 0,
pageSize: 10,
},
pageNo: 0,
pageSize: 10,
nearPageNo: 1,
positionData: '',
locateData: {
lng: '',
lat: '',
},
selectList: ["选项1", "选项2", "选项3", "选项4"],
select2List: ["排序1", "排序2", "排序3", "排序4"],
foodList: [],
tabs: [
"景区",
"美食",
"酒店",
"公共厕所",
"停车场",
"加油站",
"充电桩",
"医院",
"商业街",
"便利店",
'公安',
'消防'
],
scenicList: [],
hotelList: [],
travalList: [],
wcListOne: [],
parkList: [],
jzzList: [],
cdzList: [],
yyList: [],
syjList: [],
bldList: [],
gaList: [],
xfList: [],
curTab: this.$route.params.index,
getBarWidth: function (index) {
const homeTab = [2, 2, 2, 2, 2, 3];
return homeTab[index] * 0.32 + "rem";
},
infoWindow: "",
map: {},

location: {},
infiniteAll: false,
infiniteStatus: false,
allProduct: [],
foodPageSize: 500,
xcShow: [],
cyShow: [],
allLong: "",
listName: [
"scenicList",
"foodList",
"hotelList",
"wcListOne",
"parkList",
"jzzList",
"cdzList",
"yyList",
"syjList",
"bldList",
"gaList",
'xfList'
],
poiType: {
'WC': { name: "公共厕所", key: "127003" },
'PARK': { name: "停车场", key: "127002" },
'JYZ': { name: "加油站" },
'CDZ': { name: '充电桩', key: '127009' },
'YY': { name: "医院" },
'SYJ': { name: '商业街', key: '127011' },
'BLD': { name: "便利店" },
},
center: [100.619405,36.284158],
isShowContentScroll: true,
showMapList: false,
guideData: {},
isWork: false,
wxLink: false,
gaType: 127023,
xfType: 127012,
};
},
filters: {
showLevel (key) {
const level = {
102001: "非",
102002: 1,
102003: 2,
102004: 3,
102005: 4,
102006: 5,
};
return level[key + ""];
},
},

computed: {
getPoiList () {
let list = [];
switch (this.curTab) {
case 3:
list = this.wcListOne;
break;
case 4:
list = this.parkList;
break;
case 5:
list = this.jzzList;
break;
case 6:
list = this.cdzList;
break;
case 7:
list = this.yyList;
break;
case 8:
list = this.syjList;
break;
case 9:
list = this.bldList;
break;
case 10:
list = this.gaList;
break;
case 11:
list = this.xfList;
break;
}
return list;
},
},

mounted () {
document.title = "城市服务";

mapUtil.locate((data) => {
this.positionData = data
this.locationResult(data);

this.mountedAfter()
}, (data) => {
this.positionData = data
this.locationResult(data);
this.mountedAfter()
})

},
methods: {
mountedAfter() {
this.getScenicList();
this.getStoreList();
this.gethotelList();
this.apiPoi(this.gaType).then(data => {
let _this = this
_this.gaList = data.map(item => {
item._source.distance = mapUtil.getDistance(_this.macLnt, _this.macLat, item._source.longitude, item._source.latitude)
return item
})
})
this.apiPoi(this.xfType).then(data => {
let _this = this
_this.xfList = data.map(item => {
console.log(_this.macLnt, _this.macLat, 'qqq')
item._source.distance = mapUtil.getDistance(_this.macLnt, _this.macLat, item._source.longitude, item._source.latitude)
return item
})
})


if (this.$route.params.index) {
this.curTab = this.$route.params.index
? (this.curTab = this.$route.params.index)
: 0;
setTimeout(() => {
this.tabsChange(JSON.parse(this.curTab));
}, 1000);
}



if (util.isWeiXin()) {
const shareData = typeof (shareData) === 'undefined' ? {
title: this.PAGE_TITLE + "导览",
desc: '圣湖之光，大景海晏，海晏欢迎您~~',
imgUrl: window.location.origin + '/static/-img/banner_img.png',
link: window.location.href
} : shareData;
this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {

util.initWxConfig(response.data.data, shareData);

});

}


var mybody = document.getElementsByClassName("scrollBox")[0];

var startX, startY;
mybody.addEventListener(
"touchstart",
function (ev) {

startX = ev.touches[0].pageX;
startY = ev.touches[0].pageY;
},
false
);
var _this = this;
mybody.addEventListener(
"touchmove",
function (ev) {
var endX, endY;

endX = ev.changedTouches[0].pageX;
endY = ev.changedTouches[0].pageY;
var X = endX - startX;
var Y = endY - startY;
if (Math.abs(Y) > Math.abs(X) && Y > 0) {
if (document.getElementsByClassName("heght-wirp")[0].scrollTop == 0) {
_this.toTop();
_this.animation = false;
_this.showFitlerList = false;
}
} else if (Math.abs(Y) > Math.abs(X) && Y < 0) {
_this.animation = true;

} else {
_this.animation = false;
}
},
false
);
},
stopPropagation (e) {
if (!this.animation) {
e.stopPropagation();
e.preventDefault();
}
},
clearValue () {
this.value = "";
},
closeFilter () {
this.showFitlerList = false;
this.tabIndex = 0;
},
handlerFilterItem (item) {
this.showFitlerList = false;
this.tabIndex = 0;
this.curType = item;
switch (this.curTab) {
case 1:
this.getStoreList();
break;
case 2:
this.gethotelList();
break;
}
},
handlerFilter (i) {
if (i == 2) {
if (this.tabIndex == i) {
this.tabIndex = 0;
} else {
this.tabIndex = i;
}
this.weight = !this.weight;
this.showFitlerList = false;
this.gethotelList();
} else {
this.tabIndex = i;
this.showFitlerList = true;
}
},
cratedAmap (center) {
if (this.location && this.location.adcode && this.location.adcode.includes(this.AREA_CODE.AREACODE)) {
center = [this.location.position.lng, this.location.position.lat];
} else {
center = this.center
}
var _this = this;
const map = new AMap.Map("mapBox", {
resizeEnable: true, // 是否监控地图尺寸变化
zoom: 12, // 初始化地图层级
center: center, // //初始化地图中心点
});
var options = {

GeoLocationFirst: true, // 默认为false，设置为true的时候可以调整PC端为优先使用浏览器定位，失败后使用IP定位
showButton: true, //是否显示定位按钮
buttonPosition: "RB", //定位按钮的位置
/* LT LB RT RB */
buttonOffset: new AMap.Pixel(10, 40), //定位按钮距离对应角落的距离
showMarker: true, //是否显示定位点
markerOptions: {

offset: new AMap.Pixel(-18, -36),


},
showCircle: true, //是否显示定位精度圈
circleOptions: {

strokeColor: "#0093FF",
noSelect: true,
strokeOpacity: 0.5,
strokeWeight: 1,
fillColor: "#02B0FF",
fillOpacity: 0.25,
},
};
if (this.location.adcode.includes(this.AREA_CODE.AREACODE)) {

map.plugin(["AMap.Scale", "AMap.Geolocation"], function () {
var scale = new AMap.Scale({

offset: new AMap.Pixel(10, 40), //定位按钮距离对应角落的距离
});
map.addControl(scale);
var geolocation = new AMap.Geolocation(options); 
map.addControl(geolocation);
geolocation.getCurrentPosition();
});
}

this.map = map;
},
apiPoi(type) {
return new Promise((resolve, reject) => {
const querystring = require('querystring')
const serviceEsQuery = new EsQuery()
serviceEsQuery
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, serviceEsQuery.and, false)
.addStartWith("type", type, serviceEsQuery.and, false)
.addPage(0, 500)
const lineEsJsonQuery = JSON.stringify(serviceEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.INDEX_NAME_TYPE.poi,
'esJsonQuery': lineEsJsonQuery
})).then((response) => {
resolve(response.data.data)
})
})
},

drawMakers (list, status) {
const _this = this;

_this.infoWindow = new AMap.InfoWindow({
isCustom: true, //使用自定义窗体
offset: new AMap.Pixel(0, -30),
});
_this[list].forEach(function (marker) {
if (
marker._source &&
marker._source.longitude &&
marker._source.latitude
) {

var markerContent =
'<div class="marker-cont-item">' +
'<div class="custom-content-marker"></div>' +
'<div class="custom-content-marker-text">' +
marker._source.title +
"</div>" +
"</div>";
var newmarker = new AMap.Marker({
map: _this.map,
content: markerContent,
position: [marker._source.longitude, marker._source.latitude],
offset: new AMap.Pixel(0, -30),
});
var markerInfo = _this.getMarkerInfo(marker);
newmarker.contentdiv = markerInfo;
newmarker.datalist = marker;
/* newmarker.type = marker._index;
newmarker.toUrl = marker._source.toUrl; */
newmarker.on("click", markerClick);
} else if (marker.location) {

var markerContent =
'<div class="marker-cont-item">' +
'<div class="custom-content-marker"></div>' +
'<div class="custom-content-marker-text">' +
marker.name +
"</div>" +
"</div>";
var newmarker = new AMap.Marker({
map: _this.map,
content: markerContent,
position: [marker.location.lng, marker.location.lat],
offset: new AMap.Pixel(0, -30),
});
var markerInfo = _this.getMarkerInfo(marker);
newmarker.contentdiv = markerInfo;
newmarker.datalist = marker;
/* newmarker.type = marker._index;
newmarker.toUrl = marker._source.toUrl; */
newmarker.on("click", markerClick);
}










});
function markerClick (e) {
_this.addEventClickForMap(
e.target.contentdiv,
e.target.datalist,
e.target.getPosition()
);
}
if (status) {
_this.map.setZoom(13);
} else {
_this.map.setZoom(9);
}
},
openInfoWindow: function (data) {
var markerInfo = this.getMarkerInfo(data);
this.addEventClickForMap(
markerInfo,
data,
new AMap.LngLat(data._source.longitude, data._source.latitude)
);
},
/*
为地图详情框绑定点击事件
template: html样式模板
data: 对应标记点的数据
lnglat: 坐标 new AMap.LngLat
*/
addEventClickForMap: function (template, data, lnglat) {
this.infoWindow.setContent(template);
setTimeout(() => {
this.infoWindow.open(this.map, lnglat);
}, 400);
this.map.setCenter([lnglat.lng, lnglat.lat]);
this.animation = false;

let that = this;
setTimeout(() => {
let infobox = document.getElementsByClassName("marker-box")[0];
infobox.addEventListener("click", function () {

let url;
that.isWork = data._index == "wtcp-bic-poi" ? true : false;
switch (data._index) {
case "wtcp-bic-scenic":
url = "/scenicView/" + infobox.getAttribute("titId");
break;
case "wtcp-bic-periphery":
url = data._source.toUrl;
break;
case "wtcp-bic-hotel":
url = "/hotelDetails/" + infobox.getAttribute("titId");
break;
case "wtcp-bic-rural":
url =
"/businessViews/" +
that.XXCJ_TYPE_CODE.NJL +
"/" +
infobox.getAttribute("titId");
break;
case "wtcp-bic-poi":

that.guideData = data;
that.showMapList = true;
break;
default:
that.isWork = true
that.guideData = data;
that.showMapList = true;
break;
}
if (url != undefined) that.$router.push(url);
});
}, 700);
},
closeInfoWindow: function () {
this.map.clearInfoWindow();
},

tabsChange: function (index) {
this.clearValue();
this.center
this.curTab = index;
this.toTop();
this.animation = false;
this.showFitlerList = false;
this.$nextTick(() => {
let list = this.listName[index];
switch (index) {
case 3:
list = "wcListOne";
break;
case 4:
list = "parkList";
break;
case 5:
list = "jzzList";
break;
case 6:
list = "cdzList";
break;
case 7:
list = "yyList";
break;
case 8:
list = "syjList";
break;
case 9:
list = "bldList";
break;
case 10:
list = "gaList";
break;
case 11:
list = "xfList";
break;
}
if (index > 2) {
const center = [this.positionData.location.lng, this.positionData.location.lat] 
this.cratedAmap(center)
} else {
this.cratedAmap(this.center)
}

const status = index > 2 ? true : false;
this.drawMakers(list, status);
});
},

typeBtn (index) {
let _this = this;
_this.typecar = index;
if (index == 0) {
_this.dialog2Show = false;
_this.dialogShow = !_this.dialogShow;
} else {
_this.dialogShow = false;
_this.dialog2Show = !_this.dialog2Show;
}
},

selectBtn (item, num, index) {
if (num == 0) {
this.selectone = index;
this.category = item;
} else {
this.selecttwo = index;
this.sortcont = item;
}
this.dialogShow = false;
this.dialog2Show = false;
},
toTop () {
document.getElementsByClassName("heght-wirp")[0].scrollTo({
top: 0,
behavior: "smooth",
});
},
locationResult (val) {
this.location = val;
this.macLnt = val.location.lng
this.macLat = val.location.lat
if (val.adcode != this.AREA_CODE.AREACODE) {
this.center = [100.994430,36.896467]

if (this.curTab < 3) {
this.toastShow = true;
}
}
this.cratedAmap(this.center);



Object.keys(this.poiType).map((item) => {

this.nearBySearch(this.poiType[item].name);
return item
});

},
searchFun () {
switch (this.curTab) {
case 0:
this.getScenicList();
break;
case 1:
this.getStoreList();
break;
case 2:
this.gethotelList();
break;
case 3:
this.nearBySearch("公共厕所");
break;
case 4:
this.nearBySearch("停车场");
break;
case 5:
this.nearBySearch("加油站");
break;
case 6:
this.nearBySearch("充电桩");
break;
case 7:
this.nearBySearch("医院");
break;
case 8:
this.nearBySearch("商业街");
break;
case 9:
this.nearBySearch("便利店");
break;
case 10:
this.apiPoi(this.gaType);
break;
case 11:
this.apiPoi(this.xfType);
break;
}
},


getScenicList: function () {
const querystring = require("querystring");
const recommendEsQuery = new EsQuery();
recommendEsQuery.addString("category", this.XXCJ_TYPE_CODE.JQ, recommendEsQuery.and, false)
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)

.addPage(this.pageNo, this.foodPageSize);
if (this.value) {
recommendEsQuery.addPattern(
"title.keyword",
"*" + this.value + "*",
recommendEsQuery.and,
false
);
}
const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray());
this.$http
.post(
"/api/wtcp-kb/pub/doc/search",
querystring.stringify({
indexName: this.INDEX_NAME_TYPE.scenic,
esJsonQuery: recommendEsJsonQuery,
})
)
.then((response) => {
const scenics = response.data.data;
scenics.map((scenic) => {
scenic._source.level = scenic._source.level
? parseInt(scenic._source.level)
: scenic._source.level;
scenic._source.areaName = scenic._source.regionFullName.split(",");
scenic._source.distance = this.location.position
? mapUtil.getDistance(
this.location.position.lng,
this.location.position.lat,
scenic._source.longitude,
scenic._source.latitude
)
: "";
this.namelength = scenic._source.areaName.length;
return scenic;
});
this.$set(this, "scenicList", scenics);

this.drawMakers(this.listName[0]);
});
},

gethotelList () {
const hotelEsQuery = new EsQuery();
const querystring = require("querystring");
hotelEsQuery
.addStartWith(
"deptCode",
this.DEPT_CODE.DEPTCODE,
hotelEsQuery.and,
false
)
.addPage(this.pageNo, this.foodPageSize)
.addString("publishStatus", 1, hotelEsQuery.and, false);
if (this.curType) {
hotelEsQuery.addString("tags", this.curType, hotelEsQuery.and, false);
}










if (this.value) {
hotelEsQuery.addPattern(
"title.keyword",
"*" + this.value + "*",
hotelEsQuery.and,
false
);
}
const hotelJsList = JSON.stringify(hotelEsQuery.getArray());
this.$http
.post(
"/api/wtcp-kb/pub/doc/search",
querystring.stringify({
indexName: this.INDEX_NAME_TYPE.hotelList,
esJsonQuery: hotelJsList,
})
)
.then((res) => {
const data = res.data.data;
data.map((hotel) => {
hotel._source.distance = this.location.position
? mapUtil.getDistance(
this.location.position.lng,
this.location.position.lat,
hotel._source.longitude,
hotel._source.latitude
)
: "";
return hotel;
});
this.$set(this, "hotelList", data);
});
},

getStoreList () {
const _this = this;

const querystring = require("querystring");
const allCyEsQuery = new EsQuery();
allCyEsQuery
.addString("category", _this.XXCJ_TYPE_CODE.MS, allCyEsQuery.and, false)
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, allCyEsQuery.and, false)
.addPage(_this.pageNo, _this.foodPageSize);
if (this.value) {
allCyEsQuery.addPattern(
"title.keyword",
"*" + this.value + "*",
allCyEsQuery.and,
false
);
}
const allCyEsJsonQuery = JSON.stringify(allCyEsQuery.getArray());
_this.$http
.post(
"/api/wtcp-kb/pub/doc/search",
querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.periphery,
esJsonQuery: allCyEsJsonQuery,
})
)
.then(function (res) {
const cyList = res.data.data;
cyList.map((item) => {
item._source.toUrl =
"/businessView/" +
_this.XXCJ_TYPE_CODE.CY +
"/" +
item._source.id;
item._source.distance = _this.location.position
? mapUtil.getDistance(
_this.location.position.lng,
_this.location.position.lat,
item._source.longitude,
item._source.latitude
)
: "";
});
_this.$set(_this, "foodList", cyList);
});
},


nearBySearch (typeName, index) {
const _this = this

const keywords = typeName

AMap.service(["AMap.PlaceSearch"], function () {

const placeSearch = new AMap.PlaceSearch({

pageSize: _this.pageSize, // 单页显示结果条数
pageIndex: _this.nearPageNo, // 页码
city: _this.positionData.addressComponent.citycode, // 兴趣点城市
citylimit: true,  //是否强制限制在设置的城市内搜索
autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
extensions: 'all'   
})

const cpoint = [_this.positionData.location.lng, _this.positionData.location.lat] 

placeSearch.searchNearBy(keywords, cpoint, 3000, function (status, result) {
console.log(result)

if (result.poiList && result.poiList.count > 0) {
const { poiList: { pois: data } } = result
if (typeName == '公共厕所') {
_this.wcListOne = data.map(item => {
let _source = {}
_source.title = item.name
_source.distance = mapUtil.getDistance(_this.macLnt, _this.macLat, item.location.lng, item.location.lat)
_source.address = item.address
_source.images = ''
_source.longitude = item.location.lng
_source.latitude = item.location.lat
item._source = _source
return item
})
} else if (typeName == '停车场') {
_this.parkList = data.map(item => {
let _source = {}
_source.title = item.name
_source.distance = mapUtil.getDistance(_this.macLnt, _this.macLat, item.location.lng, item.location.lat)
_source.address = item.address
_source.images = ''
_source.longitude = item.location.lng
_source.latitude = item.location.lat
item._source = _source
return item
})
} else if (typeName == '加油站') {
_this.jzzList = data.map(item => {
let _source = {}
_source.title = item.name
_source.distance = mapUtil.getDistance(_this.macLnt, _this.macLat, item.location.lng, item.location.lat)
_source.address = item.address
_source.images = ''
_source.longitude = item.location.lng
_source.latitude = item.location.lat
item._source = _source
return item
})
} else if (typeName == '充电桩') {
_this.cdzList = data.map(item => {
let _source = {}
_source.title = item.name
_source.distance = mapUtil.getDistance(_this.macLnt, _this.macLat, item.location.lng, item.location.lat)
_source.address = item.address
_source.images = ''
_source.longitude = item.location.lng
_source.latitude = item.location.lat
item._source = _source
return item
})
} else if (typeName == '医院') {
_this.yyList = data.map(item => {
let _source = {}
_source.title = item.name
_source.distance = mapUtil.getDistance(_this.macLnt, _this.macLat, item.location.lng, item.location.lat)
_source.address = item.address
_source.images = ''
_source.longitude = item.location.lng
_source.latitude = item.location.lat
item._source = _source
return item
})
} else if (typeName == '商业街') {
_this.syjList = data.map(item => {
let _source = {}
_source.title = item.name
_source.distance = mapUtil.getDistance(_this.macLnt, _this.macLat, item.location.lng, item.location.lat)
_source.address = item.address
_source.images = ''
_source.longitude = item.location.lng
_source.latitude = item.location.lat
item._source = _source
return item
})
} else if (typeName == '便利店') {
_this.bldList = data.map(item => {
let _source = {}
_source.title = item.name
_source.distance = mapUtil.getDistance(_this.macLnt, _this.macLat, item.location.lng, item.location.lat)
_source.address = item.address
_source.images = ''
_source.longitude = item.location.lng
_source.latitude = item.location.lat
item._source = _source
return item
})
}
}

})
})
},


gpsJump: function (item) {
/**
* 定位
*/
const _this = this
if (!_this.wxLink) {
mapUtil.locate((data) => {
window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + item._source.title + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + item._source.longitude + ',' + item._source.latitude + '&sword=我的位置'
}, (data) => {
window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + item._source.title + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + item._source.longitude + ',' + item._source.latitude + '&sword=我的位置'
})
} else {
let key = 'ONGBZ-H4GE2-7ZQUP-CEFUW-7V5KE-QKFHK';  
let referer = '海晏县一机游';   
let endPoint = JSON.stringify({  //终点
'name': _item._source.title,
'latitude': item._source.latitude,
'longitude': item._source.longitude
});
let navigation = 1;
wx.miniProgram.navigateTo({
url: 'plugin://routePlan/index?key=' + key + '&referer=' + referer + '&endPoint=' + endPoint + '&navigation=' + navigation
})
}
},

getMarkerInfo: function (data) {
let imgSrc;

if (data._source.images == "" || data._source.images == []) {
imgSrc = "";
} else if (
data._source.images[0] != "" &&
typeof data._source.images[0] == "string"
) {
imgSrc = this.PIC_BASE_URL + data._source.images[0];
} else {
imgSrc = this.PIC_BASE_URL + data._source.images[0][0].fileUrl
}
let markerInfo =
"" +
'<div class="marker-box" titId="' +
data._id +
'">' +
(imgSrc
? '<div class="marker-box-img"><img src=' + imgSrc + "></div>"
: "") +
'   <div class="marker-box-info">' +
"   	<h3>" +
data._source.title +
"</h3>" +
"   	<p>" +
(data._source.address ? data._source.address : "暂无") +
"</p>" +
"   	<p>距您 " +
data._source.distance +
"</p>" +
"	</div>" +
'   <div class="marker-box-icon"><div></div></div>' +
"</div>";
return markerInfo;


},
},
};
